import React, { useEffect, useRef, useState } from "react";
import BillTypeSummary from "./BillTypeSummary";
import DelePartnerSummary from "./DelePartnerSummary";
import DeliveryBoysSumm from "./DeliveryBoysSumm";
import DiscountSummary from "./DiscountSummary";
import CategorySummary from "./CategorySummary";
import {
  ListPosShifReportBillTypeSummary,
  ListPosShifReportCategorySalesSummary,
  ListPosShifReportDeleBoysSummary,
  ListPosShifReportDelePartnerSummary,
  ListPosShifReportDetails,
  ListPosShifReportDiscountSummary,
  ListPosShiftTaxDetails,
  ListPosCheckinSummaryAPI,
} from "../ReportAPI";
import { useDispatch, useSelector } from "react-redux";
import { set_shift_report_submit, set_show_sub_headers, set_loading_progress, set_payment_type_split, set_cash_card_split, set_card_name_filter, set_bank_journal_filter } from "../ReportSlice";
import { viewCardManualAPICall } from "../../../../../API/Settings/CardAndUpiType/cardManualAPI";
import { journalListApiCall } from "../../../../../API/AccountUpdated/journalAPI";
import { setSubmitLoading } from "../../../../../Redux/Dashboard/mainDashBoardSlice";
import { convertToAMPM } from "../../../../../Js/Date";
import receiptIcon from "../../../../../Assets/Images/printReceiptIcon.svg";
import { Autocomplete, CircularProgress, Dialog, IconButton, TextField } from "@mui/material";
import { PrintOutlined } from "@mui/icons-material";
import AdvanceShiftReportPrintComponent from "../AdvancedShiftReportPRint/AdvanceShiftReportPrintComponent";
import { useReactToPrint } from "../../../../Shared/print/useHtml2PdfPrint";
import { printDomAsPdfWithPopup } from "../../../../Shared/print/printUtils";
import TaxDetailsSummary from "./TaxDetailsSummary";
import AdvanceSummaryFullPrint from "../AdvancedShiftReportPRint/AdvanceSummaryFullPrint";
import ShiftReceipt from "./ShiftReceipt";
import ShiftDevice from "./ShiftDevice";
import BillTypeTemplateSummary from "./BillTypeTemplateSummary";
import { getTemplateAPI } from "../../../SalesNew/SalesOrders/SalesQuotation/salesQuatationAPI";

function ShiftReportTable() {
  const dispatch = useDispatch();
  const { shiftReportBranch, shiftReportShift, shiftBtnClicked, showSubHeaders, paymentTypeSplit, cashCardSplit, cardNameFilter, bankJournalFilter } =
    useSelector((state) => state.posReportshiftSlice);
  const cardManualList = useSelector((state) => state.cardManualSlice.value);
  const journalList = useSelector((state) => state.journalSlice.value);
  const bankJournalList = (journalList || []).filter((item) => item?.type === "bank");
  const submitLoading = useSelector((state) => state.mainDashBoardSlice.submitLoading);
  const template = useSelector(
    (state) => state?.salesQuatationSlice?.setTemplate
  );
  const companyProfileData = useSelector((state) => state?.companyProfileSlice?.userValue);
  const billTypeSummary = useSelector((state) => state.posReportshiftSlice.billTypeSummary);
  const shiftReporCheckinSummary = useSelector((state) => state.posReportshiftSlice.shiftReporCheckinSummary);

  const buttonsArray = [
    "BILL TYPE",
    "DELIVERY PARTNERS",
    "DELIVERY BOYS",
    "DISCOUNT",
    "CATEGORY/SALES",
    "TAX DETAILS",
    // "RECEIPT",
    "DEVICE",
  ];
  const [selectedButton, setSelectedButton] = useState("BILL TYPE");
  const [printPreviewOpen, setPrintPreviewOpen] = useState(false);

  const printRef = useRef();
  const printAllinOne = useRef();

  const shiftDetails = useSelector(
    (state) => state.posReportshiftSlice.shiftReportDetails
  );

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);
  };

  const handleCheckboxChange = (event) => {
    dispatch(set_show_sub_headers(event.target.checked));
  };

  const waitForContentReady = async (root) => {
    let tries = 0;
    while (tries < 50) {
      if (!root) break;
      const rows = root.querySelectorAll('tr');
      if (rows.length > 0 && root.offsetHeight > 0) return true;
      await new Promise(r => setTimeout(r, 100));
      tries++;
    }
    return false;
  };

  const handleOpenPrintPreview = () => {
    setPrintPreviewOpen(true);
  };

  const handlePrintKot = async () => {
    const printSettingsString = localStorage.getItem('PrinterSettings');
    const printSettings = printSettingsString ? JSON.parse(printSettingsString) : null;

    if (printSettings?.useSocketPrint && printSettings?.receiptPrinter && selectedButton === "BILL TYPE") {
      try {
        const { socketShiftReportPrint } = await import('../../../Settings/Device Settings/socketPrintService');
        const empCheckInList = shiftReporCheckinSummary?.empCheckIn || [];
        const checkoutInfo = empCheckInList.length > 0
          ? empCheckInList.map((emp) => ({
              name: emp?.empData?.staff_name || emp?.employeeName || 'Unknown',
              checkInDate: emp?.checkInDate || shiftDetails?.startDate || '',
              checkInTime: emp?.checkInTime ? convertToAMPM(emp.checkInTime) : '',
              checkOutDate: emp?.checkOutDate || '',
              checkOutTime: emp?.checkOutTime ? convertToAMPM(emp.checkOutTime) : '',
              hasCheckedOut: emp?.checkOutDate && emp.checkOutDate !== 'null' && emp.checkOutDate !== 'Invalid date',
            }))
          : [{
              name: shiftDetails?.employeeName || 'Unknown',
              checkInDate: shiftDetails?.startDate || '',
              checkInTime: shiftDetails?.startTime ? convertToAMPM(shiftDetails.startTime) : '',
              checkOutDate: shiftDetails?.endDate || '',
              checkOutTime: shiftDetails?.endTime ? convertToAMPM(shiftDetails.endTime) : '',
              hasCheckedOut: !!shiftDetails?.endDate,
            }];

        // Get logo as base64
        let logoBase64 = null;
        if (companyProfileData?.logo) {
          try {
            const resp = await fetch(companyProfileData.logo);
            const blob = await resp.blob();
            logoBase64 = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            });
          } catch (e) { console.error('Logo fetch error:', e); }
        }

        await socketShiftReportPrint({
          printerName: printSettings.receiptPrinter,
          printerWidth: printSettings.receiptSize === "80" ? 48 : 32,
          logoBase64,
          logoWidth: printSettings.logoWidth || 320,
          logoHeight: printSettings.logoHeight || 128,
          mode: printSettings.receiptImgMode || 1,
          companyName: companyProfileData?.companyName || '',
          companyAddress: companyProfileData?.companyAddress || '',
          companyEmail: companyProfileData?.companyEmail || '',
          contactNumber: companyProfileData?.contactNumber || '',
          shiftId: shiftDetails?.shiftId || '',
          employeeName: shiftDetails?.employeeName || '',
          startDate: shiftDetails?.startDate || '',
          startTime: shiftDetails?.startTime ? convertToAMPM(shiftDetails.startTime) : '',
          endDate: shiftDetails?.endDate || '',
          endTime: shiftDetails?.endTime ? convertToAMPM(shiftDetails.endTime) : '',
          checkoutInfo,
          billTypeSummary,
          showSubHeaders,
          paymentTypeSplit,
          cashCardSplit,
          decimalPosition: localStorage.getItem('decimalPosition') || '2',
        });
        console.log('Shift report printed via socket ESC/POS');
        setPrintPreviewOpen(false);
        return;
      } catch (err) {
        console.error('Socket shift report print failed, falling back to PDF:', err);
      }
    }

    // Fallback: PDF print
    if (!printRef.current) return;
    await waitForContentReady(printRef.current);
    await printDomAsPdfWithPopup(printRef.current, { widthMM: 80 });
    setPrintPreviewOpen(false);
  };

  const printFullReport = async () => {
    if (!printAllinOne.current) return;
    await waitForContentReady(printAllinOne.current);
    await printDomAsPdfWithPopup(printAllinOne.current, { widthMM: 210 });
  };

  useEffect(() => {
    getTemplateAPI();
    viewCardManualAPICall();
    journalListApiCall();
  }, []);

  useEffect(() => {
    if (shiftBtnClicked === "submit") {
      const fetchShiftData = async () => {
        if (!shiftReportBranch?._id || !shiftReportShift?._id) {
          dispatch(set_shift_report_submit(null));
          return;
        }

        const body = {
          branchId: shiftReportBranch._id,
          shiftId: shiftReportShift._id,
        };

        dispatch(setSubmitLoading(true));
        dispatch(set_loading_progress(0));

        // Define API calls with progress tracking
        const apiCalls = [
          { fn: () => ListPosShifReportBillTypeSummary(body), name: 'Bill Type' },
          { fn: () => ListPosShifReportDelePartnerSummary(body), name: 'Delivery Partners' },
          { fn: () => ListPosShifReportDiscountSummary(body), name: 'Discount' },
          { fn: () => ListPosShifReportDeleBoysSummary(body), name: 'Delivery Boys' },
          { fn: () => ListPosShifReportCategorySalesSummary(body), name: 'Category Sales' },
          { fn: () => ListPosShifReportDetails(body), name: 'Shift Details' },
          { fn: () => ListPosShiftTaxDetails(body), name: 'Tax Details' },
          { fn: () => ListPosCheckinSummaryAPI({ shiftId: shiftReportShift._id }), name: 'Checkin Summary' },
        ];

        const totalCalls = apiCalls.length;
        let completedCalls = 0;

        try {
          // Execute API calls sequentially to track progress
          for (const apiCall of apiCalls) {
            try {
              await apiCall.fn();
            } catch (err) {
              console.error(`Error loading ${apiCall.name}:`, err);
            }
            completedCalls++;
            const progress = Math.round((completedCalls / totalCalls) * 100);
            dispatch(set_loading_progress(progress));
          }
        } catch (error) {
          console.error("Error loading shift report data:", error);
        } finally {
          dispatch(setSubmitLoading(false));
          dispatch(set_loading_progress(0));
          dispatch(set_shift_report_submit(null));
        }
      };

      fetchShiftData();
    }
  }, [shiftBtnClicked, shiftReportBranch?._id, shiftReportShift?._id, dispatch]);

  return (
    shiftDetails && (
      <div
        style={{ marginTop: "8px", backgroundColor: "white", height: "74vh", position: "relative" }}
        className="flex-column advance-shift-report-table-container"
      >
        {submitLoading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(255, 255, 255, 0.8)",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={48} thickness={4} />
            <p style={{ marginTop: "12px", fontWeight: 600, color: "#555" }}>
              Loading shift report...
            </p>
          </div>
        )}
        <style>
          {`
            @media print {
              /* Hide only the tabs section - keep everything else */
              .shiftButton-div {
                display: none !important;
              }
              
              /* Hide print icons within shift info */
              .single-view-left-ctn .MuiIconButton-root {
                display: none !important;
              }
              
              /* Show only the print title */
              .print-button-title {
                display: block !important;
                font-size: 16px;
                font-weight: bold;
                margin: 10px 20px;
                text-align: center;
              }
            }
            /* Hide scrollbar in print preview dialog for Chrome/Safari */
            .billing-parent-wrapper > div:first-child::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>

        <div
          className="single-view-left-ctn"
          style={{
            width: "60%",
            minWidth: "fit-content",
            maxWidth: "550px",
            padding: "16px",
            margin: "1%",
            marginBottom: "0",
            backgroundColor: "#fcfafa",
          }}
        >
          <h3 style={{ margin: "0", cursor: "pointer", fontSize: "larger" }}>
            {shiftDetails?.branchName}
            <IconButton onClick={printFullReport} title="Print" style={{ marginLeft: "15px" }}>
              <img src={receiptIcon} alt="print receipt" width="22" height="22" />
            </IconButton>
          </h3>
          <div className="justify-space-between" style={{ display: "flex" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="single-view-info-ctn-left flex-column">
                <p style={{ margin: "1px" }}>Shift</p>
                <p style={{ margin: "1px" }}>Employee</p>
              </div>
              <div className="single-view-info-ctn-right flex-column">
                <p style={{ margin: "1px" }}>{shiftDetails?.shiftId}</p>
                <p style={{ margin: "1px" }}>{shiftDetails?.employeeName}</p>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="single-view-info-ctn-left flex-column">
                <p style={{ margin: "1px" }}>Start Date</p>
                <p style={{ margin: "1px" }}>End Date</p>
              </div>
              <div className="single-view-info-ctn-right flex-column">
                <p style={{ margin: "1px" }}>
                  {shiftDetails?.startDate}: {convertToAMPM(shiftDetails?.startTime)}
                </p>
                {shiftDetails?.endDate ? (
                  <p style={{ margin: "1px" }}>
                    {shiftDetails?.endDate}: {convertToAMPM(shiftDetails?.endTime)}
                  </p>
                ) : (
                  <p style={{ margin: "1px" }}>Active Shift</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* BUTTONS */}
        <div className="shiftButton-div button" style={{ padding: "0px 0 0 17px" }}>
          {buttonsArray.map((button, i) => (
            <button
              key={i}
              className={`${selectedButton === button ? "selected-button" : ""} tab-btn`}
              onClick={() => handleButtonClick(button)}
            >
              {button}
              {selectedButton === button && (
                <IconButton onClick={handleOpenPrintPreview} title="Print Preview">
                  <img src={receiptIcon} alt="print receipt" width="20" height="20" />
                </IconButton>
              )}
            </button>
          ))}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "auto",
              gap: "10px",
              padding: "1%",
            }}
          >
            <label htmlFor="detailsCheckBox" style={{ fontSize: "14px", cursor: "pointer", userSelect: "none" }}>
              Details
            </label>
            <input
              id="detailsCheckBox"
              type="checkbox"
              className="toggle-checkbox"
              checked={showSubHeaders}
              onChange={handleCheckboxChange}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "1%",
              cursor: "pointer",
              userSelect: "none",
            }}
            onClick={() => dispatch(set_cash_card_split(!cashCardSplit))}
          >
            <span style={{ fontSize: "13px" }}>CASH/CARD Split</span>
            <span style={{ fontSize: "16px" }}>{cashCardSplit ? "\u2611" : "\u2610"}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "1%",
              cursor: "pointer",
              userSelect: "none",
            }}
            onClick={() => dispatch(set_payment_type_split(!paymentTypeSplit))}
          >
            <span style={{ fontSize: "13px" }}>Expences Payment type split</span>
            <span style={{ fontSize: "16px" }}>{paymentTypeSplit ? "\u2611" : "\u2610"}</span>
          </div>
          {cashCardSplit && (
            <>
              <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                options={cardManualList || []}
                value={cardNameFilter || []}
                onChange={(e, newValue) => dispatch(set_card_name_filter(newValue))}
                getOptionLabel={(option) => option?.cardName || ""}
                isOptionEqualToValue={(o, v) => o?._id === v?._id}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Card Name" />
                )}
                sx={{ minWidth: 180, maxWidth: 260 }}
              />
              <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                options={bankJournalList || []}
                value={bankJournalFilter || []}
                onChange={(e, newValue) => dispatch(set_bank_journal_filter(newValue))}
                getOptionLabel={(option) => option?.journalName || ""}
                isOptionEqualToValue={(o, v) => o?._id === v?._id}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Bank Journal" />
                )}
                sx={{ minWidth: 180, maxWidth: 260 }}
              />
            </>
          )}
        </div>

        {/* PRINT TITLE */}
        <div className="print-button-title" style={{ display: "none" }}>
          {selectedButton}
        </div>

        {/* TABS CONTENT */}
        {selectedButton === "BILL TYPE" && (
          <>
            {template?.shiftReportReceiptTemplate === "template2" ? (
              <BillTypeSummary showSubHeaders={showSubHeaders} paymentTypeSplit={paymentTypeSplit} cashCardSplit={cashCardSplit} cardNameFilter={cardNameFilter} bankJournalFilter={bankJournalFilter} />
            ) : (
              <BillTypeTemplateSummary showSubHeaders={showSubHeaders} paymentTypeSplit={paymentTypeSplit} cashCardSplit={cashCardSplit} cardNameFilter={cardNameFilter} bankJournalFilter={bankJournalFilter} />
            )}
          </>
        )}
        {selectedButton === "DELIVERY PARTNERS" && <DelePartnerSummary showSubHeaders={showSubHeaders} />}
        {selectedButton === "DELIVERY BOYS" && <DeliveryBoysSumm showSubHeaders={showSubHeaders} />}
        {selectedButton === "DISCOUNT" && <DiscountSummary showSubHeaders={showSubHeaders} />}
        {selectedButton === "CATEGORY/SALES" && <CategorySummary showSubHeaders={showSubHeaders} />}
        {selectedButton === "TAX DETAILS" && <TaxDetailsSummary showSubHeaders={showSubHeaders} />}
        {/* {selectedButton === "RECEIPT" && <ShiftReceipt showSubHeaders={showSubHeaders} />} */}
        {selectedButton === "DEVICE" && <ShiftDevice showSubHeaders={showSubHeaders} />}

        {/* PRINT PREVIEW DIALOG */}
        <Dialog
          open={printPreviewOpen}
          maxWidth="sm"
          onClose={() => setPrintPreviewOpen(false)}
          onKeyDown={(e) => e.key === "Escape" && setPrintPreviewOpen(false)}
        >
          <div className="billing-parent-wrapper" style={{ position: 'relative' }}>
            <div style={{ maxHeight: '80vh', overflowY: 'auto', padding: '10px', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              <AdvanceShiftReportPrintComponent selectedButton={selectedButton} />
            </div>
            <div className="invoice-print-icon-container" style={{ display: 'flex', justifyContent: 'center', padding: '10px', gap: '10px', borderTop: '1px solid #eee' }}>
              <IconButton
                onClick={handlePrintKot}
                sx={{ backgroundColor: "#d3e3ec" }}
                title="Print"
              >
                <PrintOutlined sx={{ color: "#000" }} />
              </IconButton>
            </div>
          </div>
        </Dialog>

        {/* PRINT COMPONENTS (hidden, for PDF fallback) */}
        <div className="print-parent" style={{ position: 'absolute', top: '-10000px', left: '-10000px', width: '100%' }}>
          <div ref={printRef}>
            <AdvanceShiftReportPrintComponent selectedButton={selectedButton} />
          </div>
        </div>
        <div className="print-parent" style={{ position: 'absolute', top: '-10000px', left: '-10000px', width: '100%' }}>
          <div ref={printAllinOne}>
            <AdvanceSummaryFullPrint />
          </div>
        </div>
      </div>
    )
  );
}

export default ShiftReportTable;
